import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import SidImg1 from '../../images/testimonial/img-4.jpg'
// import SidImg2 from '../../images/testimonial/img-5.jpg'
import client1 from '../../images/testimonial/client/1.jpg'
import client2 from '../../images/testimonial/client/2.jpg'

import Quote from '../../images/testimonial/quote-2.svg'

const testimonials = [
    {
        id: '01',
        img: client1,
        Des: "QHB next level flexitarian yr bicycle rights waistcoat bit austin tofu-daa glossier whatever scenester snack wave literally can shaman grained.",
        Title: 'Leslie Alexander',
        Sub: "Marketing Coordinator",
    },
    {
        id: '02',
        img: client2,
        Des: "QHB next level flexitarian yr bicycle rights waistcoat bit austin tofu-daa glossier whatever scenester snack wave literally can shaman grained.",
        Title: 'John Abraham',
        Sub: "WEb Developer",
    },
    {
        id: '03',
        img: client1,
        Des: "QHB next level flexitarian yr bicycle rights waistcoat bit austin tofu-daa glossier whatever scenester snack wave literally can shaman grained.",
        Title: 'Leslie Alexander',
        Sub: "Marketing Coordinator",
    },
   
    {
        id: '04',
        img: client2,
        Des: "QHB next level flexitarian yr bicycle rights waistcoat bit austin tofu-daa glossier whatever scenester snack wave literally can shaman grained.",
        Title: 'John Abraham',
        Sub: "WEb Developer",
    },

]


const TestimonialS4 = (props) => {

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows:false,
        dots: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: true,
                    slidesToShow: 1,
                }
            },
        ]
    }
    return (
        <section className={"" + props.hclass}>
            <Slider {...settings} className="testimonial-slider-s3">
                {testimonials.slice(0, 4).map((testimonial, item) => (
                    <div className="item" key={item}>
                        <div className="content">
                            <div className="icon">
                                <img src={Quote} alt="quote" />
                            </div>
                            <h3>“{testimonial.Des}”</h3>
                            <div className="client-wrap">
                                <div className="image">
                                    <img src={testimonial.img} alt="" />
                                </div>
                                <div className="text">
                                    <h4>{testimonial.Title}</h4>
                                    <span>{testimonial.Sub}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </section>
    );
};

export default TestimonialS4;


